module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-bg-color-83d7b6067efd3ad005840d90e44e83d3.png";